<template>
  <v-card class="app-card bottom-actions__card pa-4" height="100%">
    <v-card-title class="justify-center pt-0">
      <h2>SSL Certificate</h2>
    </v-card-title>
    <gg-card-text>
      <p class="text-center">Save SSL files locally using the button below.</p>
    </gg-card-text>
    <v-card-actions class="bottom-actions pb-0">
      <v-row>
        <v-col class="text-center">
          <gg-btn class="justify-center" @click="download('pem')">Download Files</gg-btn>
        </v-col>
      </v-row>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'DownloadCertificate',
  data () {
    return {}
  },
  computed: mapGetters(['ssl']),
  methods: {
    download (x) {
      let download = document.createElement('a')
      download.target = '_blank'
      switch (x) {
        case 'crt':
          if (!this.ssl.voucher.ssl_crt) return
          download.href = 'data:attachment/pkcs8,' + encodeURI(this.ssl.voucher.ssl_crt.replace(/\n/g, '\r\n'))
          download.download = this.ssl.domain + '.crt.txt'
          break
        case 'key':
          if (!this.ssl.voucher.ssl_key) return
          download.href = 'data:attachment/x-x509-user-cert,' + encodeURI(this.ssl.voucher.ssl_key.replace(/\n/g, '\r\n'))
          download.download = this.ssl.domain + '.key.txt'
          break
        case 'pem':
          if (!this.ssl.voucher.ssl_crt || !this.ssl.voucher.ssl_key) return
          let bundle = ''
          bundle += this.ssl.voucher.ssl_crt.replace(/\n/g, '\r\n')
          if (this.ssl.voucher.ssl_cabundle) bundle += '\r\n' + this.ssl.voucher.ssl_cabundle.replace(/\n/g, '\r\n')
          bundle += '\r\n' + this.ssl.voucher.ssl_key.replace(/\n/g, '\r\n')
          download.href = 'data:attachment/x-pem-file,' + encodeURI(bundle)
          download.download = this.ssl.domain + '.pem.txt'
          break
        default:
          return
      }

      download.click()
    },
  },
}
</script>

<style scoped>
  .bottom-actions__card {
    display: flex;
    flex-direction: column;
  }
  .bottom-actions {
    margin-top: auto;
  }
</style>
